/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dialog } from 'alurkerja-ui';
import useErrorState from '@/states/error.state';

export const errorHandler = (err: any) => {
  const message = err?.response?.data?.message || err?.response?.data?.error;
  const isStringMessage = typeof message === 'string' && message.trim().length > 0;

  // Don't show error dialog for 401 as it's handled by axios interceptor
  if (err?.response?.status === 401) {
    console.warn('Authentication error - token refresh in progress');
    return;
  }

  // Handle 403 by setting global state
  if (err?.response?.status === 403) {
    useErrorState.getState().set403Error(true);
    return;
  }

  if (err?.response?.status === 422) {
    Dialog.error({ description: err?.response?.data.message });
  } else if (err?.code === 'ERR_NETWORK' || err?.code === undefined) {
    Dialog.error({ title: 'Network Error', description: 'Please try again later' });
  } else if (message === 'ERROR LDAP') {
    Dialog.error({ title: 'Authentication Error', description: 'Please check your credentials' });
  } else if (message === 'Bad Request') {
    Dialog.error({ title: 'Bad Request', description: err?.response?.data?.data });
  } else if (err?.response?.status === 409) {
    Dialog.error({ title: 'Conflict', description: err?.response?.data?.error || 'Conflict occurred' });
  } else if (message === 'org profile not found' || message === 'org chart node not found') {
    Dialog.error({
      title: 'Organization Not Found',
      description: 'Please create your company information first to continue.',
    });
  } else {
    Dialog.error({ title: 'Error', description: isStringMessage ? message : 'Please try again later' });
  }
};
